import React from "react";
import styled from "styled-components";
import { H5 } from "storybook-components/Typography";
import DefaultAuthorIcon from "../PostPreviewCards/images/default-author-icon.svg";

const checkAuthorImage = authorImg => {
  if (authorImg) {
    return <AuthorImage src={authorImg} alt="Image of author" />;
  }
  return <AuthorImage src={DefaultAuthorIcon} alt="Image of author" />;
};

const AuthorInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
const AuthorImageHalo = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  margin: 0.5rem auto 1rem;
  border: ${({ theme }) => theme.colors.green5} solid 2px;
  border-radius: 100%;
`;

const AuthorImage = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin: auto;
  background: #f7f7f9;
`;

const AuthorInfo = styled(H5)`
  margin: 0 0 1.5rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.gray12};
`;

export default ({ authorImg, authorName, authorTitle }) => (
  <AuthorInfoWrapper>
    <AuthorImageHalo>{checkAuthorImage(authorImg)}</AuthorImageHalo>
    <AuthorInfo>{`${authorName}, ${authorTitle}`}</AuthorInfo>
  </AuthorInfoWrapper>
);
